module.exports = __webpack_public_path__ + "img/industry-architecture.b04c6538.jpg";